import { Box, Divider, Typography } from "@mui/material";

export default function PaperWithHeader(props: {
    label: string;
    children: JSX.Element | JSX.Element[];
}) {
    return (
        <Box>
            <Typography color="primary">{props.label}</Typography>

            <Divider sx={{ mt: 1, mb: 1.5 }} />

            {props.children}
        </Box>
    );
}
